import { z } from "zod/v4";

export const RecentUpdateSchema = z.object({
	title: z.string().min(1),
	link: z.url(),
	publishedAt: z.coerce.date(),
});

export type RecentUpdate = z.infer<typeof RecentUpdateSchema>;
